// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Xr","withContent":"e_Yr","content":"e_Zr","iconBox":"e__r","icon":"e_0r","hidden":"e_1r"};